import { IpDetectionBar } from "@PegasusCore/pegasus-one-territory/src/script.js";
import Alpine from "alpinejs";

// You can do the same thing with the IpDetectionBar
export class MyIpDetectionBar extends IpDetectionBar {
    getIPInfo() {
        let IPCookie;

        if (pegasus.getCookie('IP_VERIFIED') !== undefined) {
            IPCookie = pegasus.getCookie('IP_VERIFIED');
        }

        const data = new FormData();
        data.append('action', 'ip_detect_notify');
        data.append('url', window.location.href);
        console.log('extended');
        fetch(ajaxurl, {
            method: 'POST',
            credentials: 'same-origin',
            body: data
        }).then(async resp => {
            const data = await resp.json();

            console.log(data);

            if (data.current_view !== undefined) {
                this.currentView = data.current_view;
            }

            if (typeof IPCookie !== 'undefined' && IPCookie !== '') {
                IPCookie = JSON.parse(IPCookie);
                if (parseInt(IPCookie.territory) === data.current_view) {
                    data.show_bar = false;
                }
                this.territory = parseInt(IPCookie.territory);
            }

            if (data.show_bar !== undefined) {
                this.matchingLocation = !data.show_bar;

                setTimeout(() => {
                    this.show = data.show_bar;
                }, 500)
            }

            return data
        }).then(data => {
            if(typeof data.destination !== 'undefined' && data.destination !== '') {
                this.destination = data.destination;
            }

            if (this.matchingLocation === false) {
                if (typeof IPCookie !== 'undefined' && IPCookie !== '') {
                    if (parseInt(IPCookie.territory) === parseInt(document.body.dataset.territory)) {
                        this.matchingLocation = true;
                        this.show = false;
                    }
                }
                const countrySelector = this.$root.querySelector('select');
                if (!countrySelector) {
                    return;
                }
                countrySelector.value = data.should_view_home;
                countrySelector.dispatchEvent(new Event('change'));
            }
        });
    }
}
Alpine.data('ipDetectionBar', () => new MyIpDetectionBar());
